import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Client, ClientLocation, ClientVendorCreds} from '../../clients-module/models/clientLocation';
import {AuthService} from '../../services/auth.service';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {ClientService} from '../../clients-module/services/client.service';
import {ToastrService} from 'ngx-toastr';
import {PhonePipe} from '../../pipes/phone.pipe';
import {Subscription} from 'rxjs';
import {ObjectUpdatePayload} from '../../models/screeningInvite';
import {ValidationService} from '../../services/validation.service';
import {PropertyService} from '../services/property.service';
import {NgForm} from '@angular/forms';
import {UserService} from 'src/app/users-module/services/user.service';
import {UserLight} from 'src/app/users-module/models/userLight';
import { AddressService } from 'src/app/services/address.service';
import { RiqAlertComponent } from 'src/app/shared-components-module/riq-alert/riq-alert.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-properties-edit',
  templateUrl: './properties-edit.component.html',
  styleUrls: ['./properties-edit.component.less']
})
export class PropertiesEditComponent implements OnInit, OnDestroy {
  @ViewChild('form', {}) ngForm: NgForm;
  public propertyId: number;
  public clientId: number;
  private activeClientLocation: ClientLocation = new ClientLocation();
  public get model(): ClientLocation {
    return this.activeClientLocation;
  }
 public showErrors: boolean = false;
  constructor(public validator: ValidationService,
              public phone: PhonePipe,
              public auth: AuthService,
              public location: Router,
              public activatedRoute: ActivatedRoute,
              public properties: PropertyService,
              public clients: ClientService,
              public toastr: ToastrService,
              private usrs: UserService,
              private addy: AddressService,
              public modalService: NgbModal) {
  }

  public ngOnInit(): void {

    this.activeClientLocation.creds = new ClientVendorCreds();
    this.activatedRoute.paramMap.subscribe((p: ParamMap) => {
      this.clientId = parseInt(p.get('client'));
      if (p.get('client') && p.get('prop')) {
        this.propertyId = parseInt(p.get('prop'));
        this.properties.FetchMarketSegments();
        this.properties.FetchProperty(this.propertyId).subscribe((res: ClientLocation) => {
            if (!res.creds) {
              res.creds = Object.assign(new ClientVendorCreds(), res.creds);
              res.creds.clientLocationId = res.id;
            }
            this.activeClientLocation = Object.assign(new ClientLocation(), res);
          },
          err => this.toastr.error('Error loading property', '', {disableTimeOut: true, closeButton: true}));
      }
    });
  }
  
  public ngOnDestroy(): void {
    this.ngForm.resetForm();
  }


  public cancel(): void {
    this.ngForm.resetForm();
    this.location.navigateByUrl(`/properties/stats/${this.propertyId}/${this.clientId}`);
  }

  public save(): void {
    if (this.ngForm.valid) {
      this.properties.UpdateProperty(this.model).subscribe((scc:boolean)=>{
          this.toastr.success('Property Updated Successfully.');
          this.showErrors = false;
                // if there are credentials then send those as well
      if (this.model.creds && this.model.creds.userName && this.model.creds.password) {
        // SCRSTP-1322: we need to know if the client has a user.. if not, set the makeClientUser flag
        this.usrs.ShallowFetchUsersForClient(this.model.clientId).subscribe((u: UserLight[]) => {
            if (u.length === 0 || !u.find(u => { return u.firstName === "API"})) {
              this.model.creds.makeClientUser = true;
              
            }
            this.properties.AddVendorCreds(this.model.creds).subscribe(
              e => {
                this.model.creds.id = e;
                this.cancel();
              },
              v => {
                if(v.status === 409) this.toastr.error('Duplicate credentials found. Please review the API Username.', 'Credentials Not Saved', {disableTimeOut: true, closeButton: true});
                else this.toastr.error('Error saving credentials.', '', {disableTimeOut: true, closeButton: true});
              });
          },
          (err) => console.log(err));
      }else
          this.cancel(); // nav back to the stats screen
      },(err: any)=>{
        this.toastr.error('Property update failed.', 'Update Failed!', {disableTimeOut: true, closeButton: true});
      });
    }else {this.showErrors = true;}
  }

  handlePropDeactivation() {
    //if a user is turning this on, no issues with just binding that up and letting the user save/continue
    if(!this.model.isActive) {
      this.model.isActive = true;
      return;
    }
    else {

      const modalRef = this.modalService.open(RiqAlertComponent, { centered: true, size: 'lg' });
      modalRef.componentInstance.name = 'LocationDeactivate';
      modalRef.componentInstance.title = "Deactivate Client Location";
      modalRef.componentInstance.confirmButtonText = "Yes, I'm sure";
      modalRef.componentInstance.cancelButtonText = "Cancel";
      modalRef.componentInstance.alertBody = `Are you sure you want to deactivate ${this.model.locationName}?`;
      // modalRef.componentInstance.shown.subscribe((ev: any)=>{
        modalRef.componentInstance.evnt.subscribe((ev:boolean)=>{
          this.model.isActive = false;
          this.modalService.dismissAll();
        });
    }
  }

  public loadDefaultClientValues(): void {

    this.clients.GetClientById(this.clientId).subscribe((currentClient: Client) => {

        this.model.manualProcessing = currentClient.manualProcessing;
        this.model.autoSendAALOverride = currentClient.autoSendAAL;
        this.model.mainContactName = currentClient.mainContactName;
        this.model.mainPhone = currentClient.mainPhone;
        this.model.fax = currentClient.fax;
        this.model.mainContactEmail = currentClient.email;
        this.model.ownerName = currentClient.ownerName;
        this.model.ownerCompany = currentClient.ownerCompany;
        this.model.ownerPhone = currentClient.ownerPhone;
        this.model.ownerEmail = currentClient.ownerEmail;
        this.model.affiliateName = currentClient.affiliateName;
        this.model.rentalUnitCount = currentClient.rentalUnitCount;
      },
      err => {
        this.toastr.error('Error fetching client!', '', {closeButton: true, disableTimeOut: true});
      });
  }

}
